import React from 'react';
import T from 'components/T';
import { Field } from 'redux-form';
import { i18n } from '@international/mastodon-i18n';
import MultilineText from 'components/fields/MultilineText';

import * as V from '../../../../../../../../../../lib/validations/candidateStoryValidations';

import { CANDIDATE_STORY_MAX_CHARACTER_LIMIT } from '../../../../../../../../../../constants';

interface CandidateStoryItemTextFieldProps {
  field: string;
  customValidations?: Array<any> | undefined;
  'data-testid'?: string;
}

const CandidateStoryItemTextField = ({
  field,
  customValidations,
  'data-testid': testId = 'candidate-stories-text-field',
}: CandidateStoryItemTextFieldProps) => {
  const defaultValidations = [
    V.contentOrDocRequired,
    V.maxDocuments,
    V.maxContentLength,
  ];
  const validations = customValidations ?? defaultValidations;

  return (
    <div data-testid='candidate-story-item-text-field'>
      <p className='text-muted'>
        <T value='components.Report.CandidateStories.Modal.text.note' />
      </p>
      <Field
        name={field}
        component={MultilineText}
        maxLength={CANDIDATE_STORY_MAX_CHARACTER_LIMIT}
        placeholder={i18n.getStr(
          'components.Report.CandidateStories.Modal.text.placeholder',
        )}
        validate={validations}
        data-testid={testId}
      />
    </div>
  );
};

export default i18n.renderTranslation()(CandidateStoryItemTextField);
